module.exports = __webpack_public_path__ + "img/6000.b8204722.jpg";